import { Box, BoxProps } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function Section(props: BoxProps) {
  return <Box my={8} border={'none'} p={'none'} {...props} />;
});
